import React, { ReactNode } from 'react';
import { Translate } from 'react-redux-i18n';
import NavigationBackButton from '../../common/NavigationBackButton';
import demandeRattachement from '../../../img/notification/demande_rattachement.svg';
import RattachementRefusedTile from './components/RattachementRefusedTile';
import Button from '../../common/Button';
import { RattachementDemandEntite } from '../../../network/api/types/RattachementDemand';
import compteApi from '../../../network/api/compteApi';
import { UserDTO } from '../../../network/api/types/compte/UserDTO';
import { HOME_PAGE_ROUTE } from '../../../routes';
import creationApi from '../../../network/api/creationApi';
import { CountriesDTO } from '../../../network/api/types/CountriesDTO';
import Footer from '../../layout/Footer';

type Props = {
  rattachementDemands: RattachementDemandEntite,
  onUpdateList: () => void,
};

type State = {
  account?: UserDTO;
  countries: CountriesDTO;
};

class RattachementDemandes extends React.Component<Props, State> {
  state: State = {
    countries: {},
  };

  refusedRef = React.createRef<HTMLDivElement>();

  goToRefused = (): void => {
    this.refusedRef.current.scrollIntoView({
      behavior: 'smooth',
    });
  };

  componentDidMount(): void {
    creationApi.fetchCountries()
      .then((countries) => this.setState({ countries }));
    compteApi.fetchMyUserDetails()
      .then((user) =>
        this.setState(
          {
            account: user,
          },
        ));
  }

  render(): ReactNode {
    return (
      <div>
        <div className="navigation-header">
          <NavigationBackButton url={HOME_PAGE_ROUTE} i18nKey="rattachement.demande" image={demandeRattachement} />
          <Button
            className="navigation-button"
            onClick={this.goToRefused}
            type="third"
            i18nKey="rattachement.RefusedDemande"
          />
        </div>
        <div>
          <div className="rattachement-container">
            <div className="rattachement-content">
              <div className="subtitle-bold category-header">
                <Translate
                  value="rattachement.pendingRattachement"
                  number={this.props.rattachementDemands?.pendingRattachement?.length || 0}
                />
              </div>
              <div className="subtitle-blue">
                {this.props.rattachementDemands?.pendingRattachement?.length ? (
                  <Translate value="rattachement.collaboratorsDemande" />
                ) : (
                  <div className="rattachement-emptystate">
                    <Translate value="rattachement.noPendingRattachement" />
                  </div>
                )}
              </div>
              <div className="rattachement-demande-container">
                {
                  this.props.rattachementDemands?.pendingRattachement
                    && this.props.rattachementDemands?.pendingRattachement
                    .sort((demandA, demandB) =>
                      (new Date(demandA.creationDate) <= new Date(demandB.creationDate) ? -1 : 1))
                    .map((rattachementDemand) => (
                      <RattachementRefusedTile
                        entite={this.state.account?.entities
                          .filter((entity) => entity.id === rattachementDemand.ouEntite)[0]}
                        key={rattachementDemand.id}
                        onUpdateList={this.props.onUpdateList}
                        rattachementDemand={rattachementDemand}
                        countries={this.state.countries}
                      />
                    ))
                }
              </div>
              <div ref={this.refusedRef} className="subtitle-bold category-header">
                <Translate
                  value="rattachement.refusedDemand"
                  number={this.props.rattachementDemands?.refusedRattachement?.length || 0}
                />
              </div>
              <div className="subtitle-blue">
                {this.props.rattachementDemands?.refusedRattachement?.length ? (
                  <Translate value="rattachement.refusedDemandSubtitle" />
                ) : (
                  <div className="rattachement-emptystate">
                    <Translate value="rattachement.noRefusedDemand" />
                  </div>
                )}
              </div>
              <div className="rattachement-demande-container">
                {
                  this.props.rattachementDemands?.refusedRattachement
                    && this.props.rattachementDemands?.refusedRattachement
                    .sort((demandA, demandB) =>
                      (new Date(demandA.refusedDate) <= new Date(demandB.refusedDate) ? 1 : -1))
                     .map((rattachementDemand) => (
                       <RattachementRefusedTile
                         entite={this.state.account?.entities
                          .filter((entity) => entity.id === rattachementDemand.ouEntite)[0]}
                         key={rattachementDemand.id}
                         onUpdateList={this.props.onUpdateList}
                         rattachementDemand={rattachementDemand}
                         countries={this.state.countries}
                       />
                     ))
                }
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default RattachementDemandes;
